import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type CreateCurriculumControlsProps = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  handleSubmit: () => void;
  isSubmitting?: boolean;
};

export const CreateCurriculumControls = ({
  currentStep,
  setCurrentStep,
  handleSubmit,
  isSubmitting = false,
}: CreateCurriculumControlsProps) => {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex w-full flex-col-reverse items-center gap-2 px-8 md:flex-row md:justify-end md:gap-0 md:px-0',
        !!currentStep && 'md:justify-between',
      )}
    >
      {!!currentStep && (
        <Button
          type="button"
          variant={'link'}
          onClick={() => {
            setCurrentStep(currentStep - 1);
            scrollTo({
              top: 0,
            });
          }}
        >
          {t('text1026')}
        </Button>
      )}
      <div className="flex w-full flex-col gap-2 md:w-auto md:flex-row">
        {currentStep != 7 && (
          <Button
            type="button"
            className="w-full md:w-auto"
            onClick={() => {
              setCurrentStep(currentStep + 1);
              scrollTo({
                top: 0,
              });
            }}
          >
            {t('text1027')}
          </Button>
        )}
        <Button
          type="button"
          className="w-full md:w-auto"
          variant={'default'}
          onClick={() => handleSubmit()}
          disabled={isSubmitting}
          isLoading={isSubmitting}
        >
          {t('text1784')}
        </Button>
      </div>
    </div>
  );
};
